import React, { useEffect } from 'react';
import { connect, useDispatch } from "react-redux";
import { parametrosAguaAction, pontosMonitoramentoAction, graficoParametrosAguaAction, graficoParametrosQuantitativosAction } from '../_actions';
import { withRouter } from 'react-router-dom';
import {
   Card, CardBody, CardHeader, Container, Row, Col, FormGroup, Label } from 'reactstrap';
import { NavBar } from '../_components/navbar';
import '././styles.css';
import Select from 'react-select';
import { GraficoParametrosAgua } from './graficoParametrosAgua.component';
import { Button } from '@material-ui/core';

import alerts from '../_components/alerts';

const Graficos = (props) => {

    const dispatch = useDispatch();

    useEffect(() => {
        const { match: { params } } = props;

        dispatch(pontosMonitoramentoAction.clear());
        dispatch(pontosMonitoramentoAction.getPontosMonitoramentoSemFonteExternaSelect());
        dispatch(pontosMonitoramentoAction.getPontosMonitoramentoFonteExternaSelect());
        dispatch(parametrosAguaAction.clear());
        dispatch(parametrosAguaAction.getParametrosAguaTipo1Select());
        dispatch(parametrosAguaAction.getParametrosAguaTipo2Select());

    }, []);

       const handleSelectChange = prop => event => {
        var event2 = {
            type: 'select',
            target: {
                value: event.value
            }
        };
           dispatch(graficoParametrosAguaAction.onChangeProps(prop, event2));
           dispatch(graficoParametrosQuantitativosAction.onChangeProps(prop, event2));
    };

    const renderOptionsPontoSemFonteExterna = () => {
        return props.pontoMonitoramento.pontoMonitoramento.map((p, i) => {
            return (
                { value: p.value, label: p.text }
            );
        });
    };

    const renderOptionsPontoFonteExterna = () => {
        return props.pontoMonitoramento.pontoMonitoramento.map((p, i) => {
            return (
                { value: p.value, label: p.text }
            );
        });
    };

    const renderOptionsParametroTipo1 = () => {
        return props.parametroAgua.parametroAgua.map((p, i) => {
            return (
                { value: p.value, label: p.text }
            );
        });
    };

    const renderOptionsParametro = () => {
        return props.parametroAgua.parametroAgua.map((p, i) => {
            return (
                { value: p.value, label: p.text }
            );
        });
    };

    const buscarDadosParametrosAgua = () => {
        if (props.graficoParametrosAgua.idParametro != '' && props.graficoParametrosAgua.idPontoMonitoramento != '') {

            var filterModel = {
                idParametro: props.graficoParametrosAgua.idParametro,
                idPontoMonitoramento: props.graficoParametrosAgua.idPontoMonitoramento
            }

        dispatch(graficoParametrosAguaAction.getGrafico(filterModel, true));
        } else {
            alerts.alert('Preencha os dados!');
        }
    }

    const buscarDadosNiveisChuva = () => {
        if (props.graficoParametrosQuantitativos.idParametroNC != '' && props.graficoParametrosQuantitativos.idPontoMonitoramentoNC != '') {

            var filterModel = {
                idParametroNC: props.graficoParametrosQuantitativos.idParametroNC,
                idPontoMonitoramentoNC: props.graficoParametrosQuantitativos.idPontoMonitoramentoNC
            }

            dispatch(graficoParametrosQuantitativosAction.getGrafico(filterModel, true));
        } else {
            alerts.alert('Preencha os dados!');
        }
    }

    return (
        <div>
            <NavBar />
            <Container>
                <Card>
                    <CardHeader>
                        <Row>
                            <Col md={12}>
                                <Label className="center" for="data">Gráfico dos Parâmetros Qualitativos em um Ponto</Label>
                            </Col>
                        </Row>
                    </CardHeader>
                    <CardBody>                        
                            <Row>                      
                            <Col sm={12} md={5}>
                                    <FormGroup>
                                    <Label className="left" for="idPontoMonitoramento">Ponto de Monitoramento *</Label>
                                        <Select
                                            className="basic-single"
                                            classNamePrefix="select"
                                            value={renderOptionsPontoSemFonteExterna().filter(function (option) {
                                                return option.value == (props.graficoParametrosAgua.idPontoMonitoramento);
                                            })}
                                        onChange={handleSelectChange('idPontoMonitoramento')}
                                            isSearchable
                                        id="idPontoMonitoramento"
                                        name="idPontoMonitoramento"
                                        options={renderOptionsPontoSemFonteExterna()}
                                        />
                                    </FormGroup>
                            </Col>
                            <Col sm={12} md={5}>
                                <FormGroup>
                                    <Label className="left" for="idParametro">Parâmetro *</Label>
                                    <Select
                                        className="basic-single"
                                        classNamePrefix="select"
                                        value={renderOptionsParametroTipo1().filter(function (option) {
                                            return option.value == (props.graficoParametrosAgua.idParametro);
                                        })}
                                        onChange={handleSelectChange('idParametro')}
                                        isSearchable
                                        id="idParametro"
                                        name="idParametro"
                                        options={renderOptionsParametroTipo1()}
                                    />
                                </FormGroup>
                            </Col>
                            <Col sm={12} md={2} style={{ alignSelf: 'end' }}>
                                <FormGroup>
                                    <Button onClick={() => buscarDadosParametrosAgua()} variant="contained" color="primary">Buscar</Button>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12}>
                            <div style={{ justifyContent: 'center', alignItems: 'center', alignContent: 'center' }}>
                                    <GraficoParametrosAgua />
                                </div>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </Container>
            <Container>
                <Card>
                    <CardHeader>
                        <Row>
                            <Col md={12}>
                                <Label className="center" for="data">Gráfico dos Parâmetros Quantitativos</Label>
                            </Col>
                        </Row>
                    </CardHeader>
                    <CardBody>
                        <Row>
                            <Col sm={12} md={5}>
                                <FormGroup>
                                    <Label className="left" for="idPontoMonitoramentoNC">Ponto de Monitoramento *</Label>
                                    <Select
                                        className="basic-single"
                                        classNamePrefix="select"
                                        value={renderOptionsPontoFonteExterna().filter(function (option) {
                                            return option.value == (props.graficoParametrosQuantitativos.idPontoMonitoramentoNC);
                                        })}
                                        onChange={handleSelectChange('idPontoMonitoramentoNC')}
                                        isSearchable
                                        id="idPontoMonitoramentoNC"
                                        name="idPontoMonitoramentoNC"
                                        options={renderOptionsPontoFonteExterna()}
                                    />
                                </FormGroup>
                            </Col>
                            <Col sm={12} md={5}>
                                <FormGroup>
                                    <Label className="left" for="idParametroNC">Parâmetro *</Label>
                                    <Select
                                        className="basic-single"
                                        classNamePrefix="select"
                                        value={renderOptionsParametro().filter(function (option) {
                                            return option.value == (props.graficoParametrosQuantitativos.idParametroNC);
                                        })}
                                        onChange={handleSelectChange('idParametroNC')}
                                        isSearchable
                                        id="idParametroNC"
                                        name="idParametroNC"
                                        options={renderOptionsParametro()}
                                    />
                                </FormGroup>
                            </Col>
                            <Col sm={12} md={2} style={{ alignSelf: 'end' }}>
                                <FormGroup>
                                    <Button onClick={() => buscarDadosNiveisChuva()} variant="contained" color="primary">Buscar</Button>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12}>
                                <div style={{ justifyContent: 'center', alignItems: 'center', alignContent: 'center' }}>
                                    <GraficoParametrosAgua />
                                </div>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </Container>
        </div>
    );

};

const mapStateToProps = (state) => {
    return state;
};

const connectedGraficosPage = withRouter(connect(mapStateToProps, null, null, {
    pure: false
})(Graficos));
export { connectedGraficosPage as Graficos };